// The "paste" import: one testimonial per blank-line-separated block. A last line that starts
// with a dash ("- Jane Doe, Acme") becomes the name and, after the first comma, the company. People also
// paste the en and em dashes word processors type, so the pattern names them as escapes.
const SIGNATURE = /^\s*(?:[-\u2013\u2014~]+)\s*(.+)$/;
export const MAX_BLOCKS = 500;
export const MAX_TEXT = 3000;

export function parseBlocks(text) {
  const blocks = String(text || '').replace(/\r\n?/g, '\n').split(/\n\s*\n/).map(part => part.trim()).filter(Boolean);
  return blocks.slice(0, MAX_BLOCKS).map(block => {
    const lines = block.split('\n').map(line => line.trim()).filter(Boolean);
    let name = '';
    let company = '';
    if (lines.length > 1) {
      const match = lines[lines.length - 1].match(SIGNATURE);
      if (match && match[1].length <= 160) {
        lines.pop();
        const comma = match[1].indexOf(',');
        name = (comma >= 0 ? match[1].slice(0, comma) : match[1]).trim().slice(0, 120);
        company = comma >= 0 ? match[1].slice(comma + 1).trim().slice(0, 120) : '';
      }
    }
    const body = lines.join('\n').replace(/^["“”]+|["“”]+$/g, '').trim();
    return { text: body.slice(0, MAX_TEXT), name, company };
  }).filter(block => block.text);
}
